<template>
  <div
    class="loadingLine"
    :style="{ 'width': this.width, 'height': this.height }"
  ></div>
</template>

<script>
// import firebase from "firebase";
// import db from "@/main.js";
// import { ref } from "vue";

export default {
  name: "LoadingText",
  props: {
    width: {
      type: String,
      default: "100px",
    },
    height: {
      type: String,
      default: "20px",
    },
  },
  components: {},
  methods: {},
  setup() {
    return {};
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
.loadingLine {
  background: #ccc;
  border-radius: 7px;
  overflow: hidden;
  position: relative;
}
.loadingLine::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  height: 100%;
  width: 100%;
  background: linear-gradient(
    90deg,
    rgba(204, 204, 204, 0) 0%,
    rgba(255, 255, 255, 0.6) 50%,
    rgba(204, 204, 204, 0) 100%
  );
  animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}
</style>
